/**
 *
 * ForgotEmailForm
 *
 */

import React from 'react'
import PropTypes from 'prop-types'
import { DialogBox } from 'components/DialogBox'
import { CONTACT_US_URL } from 'utils/constants'

const messages = {
  title: 'forgot_email_title',
  captions: ['forgot_email_caption_1', 'forgot_email_caption_2'],
  submit: 'forgot_email_submit',
  secondary: 'forgot_email_secondary'
}

export class ForgotEmailForm extends React.Component {
  render () {
    return (
      <DialogBox {...this.props} messages={messages} secondaryAction={() => (window.location.href = CONTACT_US_URL)} />
    )
  }
}

ForgotEmailForm.propTypes = {
  action: PropTypes.func.isRequired
}

export default ForgotEmailForm
